import { catchError, throwError } from 'rxjs';

import { AuthService } from '../../auth/services/auth.service';
import { HttpInterceptorFn } from '@angular/common/http';
import { Router } from '@angular/router';
import { inject } from '@angular/core';
import { StorageService } from '../services/storage.service';

export const headersInterceptor: HttpInterceptorFn = (req, next) => {
  const storageService = inject(StorageService);
  const token = storageService.getToken();
  const authService = inject(AuthService);
  const router = inject(Router);

  // Verifica se o body é uma instância de FormData
  const isFormData = req.body instanceof FormData;

  const newHeaders = req.headers.set('Accept', 'application/json').set('Authorization', token ? `Bearer ${token}` : '');

  const finalHeaders = isFormData
    ? newHeaders // não seta Content-Type
    : newHeaders.set('Content-Type', 'application/json');

  const newReq = req.clone({
    headers: finalHeaders,
  });

  return next(newReq).pipe(
    catchError((error) => {
      if (error.status === 401) {
        storageService.removeToken();
        authService.logout();
      } else if (error.status === 403) {
        router.navigate(['/nao-autorizado']);
      }
      return throwError(() => error);
    }),
  );
};
